import { render, staticRenderFns } from "./TabNotations.vue?vue&type=template&id=53356a20&scoped=true&"
import script from "./TabNotations.vue?vue&type=script&lang=js&"
export * from "./TabNotations.vue?vue&type=script&lang=js&"
import style0 from "./TabNotations.vue?vue&type=style&index=0&id=53356a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53356a20",
  null
  
)

export default component.exports